"use strict";
var $ = require("../internals/export");
var globalThis = require("../internals/global-this");
var defineBuiltInAccessor = require("../internals/define-built-in-accessor");
var DESCRIPTORS = require("../internals/descriptors");
var $TypeError = TypeError;
var defineProperty = Object.defineProperty;
var INCORRECT_VALUE = globalThis.self !== globalThis;
try {
  if (DESCRIPTORS) {
    var descriptor = Object.getOwnPropertyDescriptor(globalThis, "self");
    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
      defineBuiltInAccessor(globalThis, "self", {
        get: function self() {
          return globalThis;
        },
        set: function self(value) {
          if (this !== globalThis) throw new $TypeError("Illegal invocation");
          defineProperty(globalThis, "self", {
            value,
            writable: true,
            configurable: true,
            enumerable: true
          });
        },
        configurable: true,
        enumerable: true
      });
    }
  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
    self: globalThis
  });
} catch (error) {
}
